document.addEventListener("DOMContentLoaded", () => {
  const basePath = "/assets/favicon";

  const checkFaviconExists = (path) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = path;
    });
  };

  const setFaviconAndManifest = async () => {
    const isDarkMode = window.matchMedia(
      "(prefers-color-scheme: dark)",
    ).matches;
    const folder = isDarkMode ? "light" : "dark";
    const variantPath = `${basePath}/${folder}`;

    const hasVariant = await checkFaviconExists(
      `${variantPath}/favicon-32x32.png`,
    );
    const path = hasVariant ? variantPath : basePath;

    const favicon32 = document.querySelector('link[rel="icon"][sizes="32x32"]');
    const favicon16 = document.querySelector('link[rel="icon"][sizes="16x16"]');
    const appleTouchIcon = document.querySelector(
      'link[rel="apple-touch-icon"]',
    );

    if (favicon32) favicon32.href = `${path}/favicon-32x32.png`;
    if (favicon16) favicon16.href = `${path}/favicon-16x16.png`;
    if (appleTouchIcon) appleTouchIcon.href = `${path}/apple-touch-icon.png`;

    let manifestLink = document.querySelector('link[rel="manifest"]');
    if (!manifestLink) {
      manifestLink = document.createElement("link");
      manifestLink.rel = "manifest";
      document.head.appendChild(manifestLink);
    }
    manifestLink.href = `${path}/site.webmanifest`;
  };

  setFaviconAndManifest();

  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", setFaviconAndManifest);
});
